import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute  } from '@angular/router';
import { Message } from 'primeng/primeng';
import { NgForm } from '@angular/forms';
import { AccountService } from '../account.service';

export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}

@Component({
  selector: 'app-account-crud',
  templateUrl: './account-crud.component.html',
  styleUrls: ['./account-crud.component.css'],
  providers: [AccountService],
  encapsulation: ViewEncapsulation.None
})
export class AccountCrudComponent implements OnInit {

    amountFix:number;
    purposeFix:string;
    descriptionFix:string;
    msgs: Message[] = [];
    button_caption: string = 'Сохранить';
    button_icon: string = "fa fa-save";
    accountTransactions: any = [];
    searchFilter: any = [];
    searchColumn: any = [];
    loadingTransaction: boolean = true;	
    replenishmentModal:boolean = false;
    replenishmentEditModal:boolean = false;
    payButtonVisible:boolean = false;
    editButtonVisible:boolean = false;
    accountIdForReplenishment: any;
    transactionTypes: any[] = [];
    transactionType: {};
    accountTransactionPurposeTypes: any[] = [];
    accountTransactionPurposeType: {};
    accountName : string;

    accountTransactionId:string="";
    amountEditTransaction:number;
    descriptionEditTransaction:string="";
    purposeEditTransaction:string="";

    pagination: Pagination;
    id:string;
    contractorId: string;

  constructor(    
    private router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private accountService: AccountService) { 

      activatedRoute.params.subscribe(params=>{
        this.id=params['id']; 
        this.contractorId = params['contractor_id']
      });
    }

  ngOnInit() {

    this.pagination = {
      current_page: 1,
      per_page: 1
    }
    this.fillSearchColumn();

    this.getAccountTransaction(this.searchFilter,this.id,1);

     this.accountService.getTransactionTypeList().subscribe(response => { 
       this.transactionTypes = response['data'].map(function (value) { return { label: value.name_for_admin, value: { id: value.id, name: value.name_for_admin } } });
    });

    this.accountService.getAccountTransactionPurposeTypeList().subscribe(response => { 
      this.accountTransactionPurposeTypes = response['data'].map(function (value) { return { label: value.name, value: { id: value.id, name: value.name } } });
   });

  }

   backClicked() {
        this.location.back();
  }

  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Дата создание", value: { column: "created_at", type: "calendar"} });
  }

  setFilter(data){
    this.searchFilter=data;
    this.getAccountTransaction(this.searchFilter,this.id,1);
  }
  
  onPaginate(event) {
    this.pagination.current_page=event.page + 1;
    this.getAccountTransaction(this.searchFilter,this.id,this.pagination.current_page);
  }

  getAccountTransaction(filter: any[],id:string,page:number){
    this.loadingTransaction=true;
    this.accountService.getAccountTransactionByFilter(filter,id,page).subscribe(response=>{
    this.pagination = response['pagination'] || this.pagination;
    this.accountTransactions = response['data'];
    this.loadingTransaction=false;
  });
  }

  onChangeDl1(event) {
     this.transactionType = event.value;
    console.log(event);
  }

  onChangeDl2(event) {
    this.accountTransactionPurposeType = event.value;
   console.log(event);
 }
  
  add():void{
    this.replenishmentModal=true;
    this.accountIdForReplenishment = this.contractorId;
}

  edit(id:string,amount:number,description:string,purpose:string){
    this.editButtonVisible=false;
    this.amountEditTransaction=amount;
    this.descriptionEditTransaction=description;
    this.purposeEditTransaction = purpose;
    this.accountTransactionId = id;
    this.replenishmentEditModal = true;
    this.accountIdForReplenishment = this.contractorId;
  }

onReplenishment(form: NgForm){
 this.payButtonVisible=false;
 form['value'].account_id=this.accountIdForReplenishment;
 form['value'].amount = this.amountFix;
 form['value'].purpose = this.purposeFix;
 form['value'].description = this.descriptionFix;
 form['value'].transaction_type = this.transactionType['id'];
 
 if(this.accountTransactionPurposeType!=null){
  form['value'].account_transaction_purpose_type_id = this.accountTransactionPurposeType['id'];
 }

 console.log(form['value']);

 this.accountService.createAccountTransaction(form['value']).subscribe(response=>{
   
   this.replenishmentModal=false;  
   this.payButtonVisible=false;
   this.accountTransactionPurposeType=null;
   form.reset();
   this.getAccountTransaction(this.searchFilter,this.id,this.pagination.current_page);
  });
}

onEditReplenishment(form: NgForm){
  this.editButtonVisible=true;
 
  form['value'].account_transaction_id = this.accountTransactionId;

  this.accountService.updateAccountTransaction(form['value']).subscribe(response=>{
    this.replenishmentEditModal=false;  
    this.editButtonVisible=false;
    form.reset();
    this.getAccountTransaction(this.searchFilter,this.id,this.pagination.current_page);
   });
 }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/accounts/account-crud/account-crud.component.ts